/**
 * Shared analytics helper for GA4 (G-1JFRQ8CKWL) and Google Ads (AW-18310252127).
 *
 * Loaded without `defer` from theme.liquid so `window.tcng` is ready before every
 * business script (train-booking.js, v4-esim-paid.js, my-orders.js) runs.
 *
 * - track()          fires a GA4-only event, used for funnel steps.
 * - trackPurchase()  fires GA4 `purchase` plus the Ads purchase conversion,
 *                    deduplicated by order number.
 * - trackLead()      fires GA4 `generate_lead` for the free eSIM claim and the
 *                    rental inquiry. The Ads labels for those two conversion
 *                    actions do not exist yet; add them to LEAD_ADS_LABELS once
 *                    they are created in the Ads account.
 */
(function () {
  var DEDUPE_KEY = 'tcng_conv_reported';
  var DEDUPE_LIMIT = 300;
  var ADS_ID = 'AW-18310252127';
  /* Label of the Ads conversion action named 「购买」. The account also had a
     duplicate 「购买 (1)」 holding 98hKCMycvOccEN-MgZtE; this one is the keeper. */
  var ADS_PURCHASE_LABEL = ADS_ID + '/9Bu1CMjRr-ccEN-MgZtE';

  /* Keyed by business_line. An empty label means the Ads conversion action does
     not exist yet, and trackLead() reports to GA4 only. */
  var LEAD_ADS_LABELS = {
    esim_free: 'Dax9CKriiugcEN-MgZtE',
    rental: 'R5-9CLvqjOgcEN-MgZtE'
  };

  function reportedKeys() {
    try {
      var raw = window.localStorage.getItem(DEDUPE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  /** Returns false when this key was already reported, so callers can bail out. */
  function claimKey(key) {
    var seen = reportedKeys();
    if (seen.indexOf(key) !== -1) return false;
    seen.push(key);
    try {
      window.localStorage.setItem(DEDUPE_KEY, JSON.stringify(seen.slice(-DEDUPE_LIMIT)));
    } catch (error) {
      /* Private mode blocks storage; still report rather than lose the conversion. */
    }
    return true;
  }

  function currentUserId() {
    try {
      var auth = window.TripCNAuth;
      var authState = auth && typeof auth.getState === 'function' ? auth.getState() : null;
      var user = authState && authState.user;
      return user && user.userId ? String(user.userId) : undefined;
    } catch (error) {
      return undefined;
    }
  }

  function clean(params) {
    var result = {};
    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value === undefined || value === null || value === '') return;
      result[key] = value;
    });
    return result;
  }

  function track(eventName, params) {
    if (typeof window.gtag !== 'function' || !eventName) return;
    var payload = clean(params);
    if (!payload.user_id) {
      var userId = currentUserId();
      if (userId) payload.user_id = userId;
    }
    window.gtag('event', eventName, payload);
  }

  function trackPurchase(order) {
    order = order || {};
    var orderNo = String(order.orderNo || '').trim();
    if (!orderNo) return;
    if (!claimKey('purchase:' + orderNo)) return;

    var value = Number(order.value);
    if (!isFinite(value) || value < 0) value = 0;
    var currency = order.currency || 'USD';

    track('purchase', {
      transaction_id: orderNo,
      value: value,
      currency: currency,
      business_line: order.businessLine,
      items: Array.isArray(order.items) && order.items.length ? order.items : undefined
    });

    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'conversion', clean({
      send_to: ADS_PURCHASE_LABEL,
      transaction_id: orderNo,
      value: value,
      currency: currency,
      new_customer: order.new_customer
    }));
  }

  function trackLead(lead) {
    lead = lead || {};
    var businessLine = String(lead.businessLine || '').trim();
    var referenceId = String(lead.referenceId || '').trim();
    if (!claimKey('lead:' + businessLine + ':' + (referenceId || Date.now()))) return;

    track('generate_lead', {
      transaction_id: referenceId,
      business_line: businessLine,
      value: 0,
      currency: 'USD'
    });

    var label = LEAD_ADS_LABELS[businessLine];
    if (!label || typeof window.gtag !== 'function') return;
    window.gtag('event', 'conversion', clean({
      send_to: ADS_ID + '/' + label,
      transaction_id: referenceId
    }));
  }

  window.tcng = {
    track: track,
    trackPurchase: trackPurchase,
    trackLead: trackLead
  };
})();
